import { render } from "./tubeDeleteBtn.vue?vue&type=template&id=f2d817e8"
import script from "./tubeDeleteBtn.vue?vue&type=script&lang=js"
export * from "./tubeDeleteBtn.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__